import * as yup from "yup";
import { axios } from "../../utils/axios";
import { toast } from "react-toastify";
import { toastOptions } from "../../config/toast";

export const schemaBusquedaInfraccion = yup
  .object({
    numero_acta: yup
      .string()
      .required("Número de acta requerido")
      // .matches(/^(DTP|DTM)-(?!0+$)[0-9]+$/i, {
      // .matches(/^(MVD)-(?!0+$)[0-9]+$/i, {
      .matches(/^(?!0+$)[0-9]+$/i, {
        message: "Formato incorrecto",
        excludeEmptyString: true,
      }),
  })
  .required();

export const onSubmitBusquedaInfraccion = async (formActa, setActa, reset, setIsLoading) => {
  setIsLoading(true);

  const response = await axios().get(`get_infraccion_notificador/${formActa.numero_acta}`);
  const { data, error } = response.data;

  setIsLoading(false);

  if (data) {
    setActa(data);
    reset();
    return;
  }

  if (error) {
    toast.error(error, toastOptions);
    setActa(null);
    reset();
    return;
  }
};
